<template>
  <div class="index h-full" :style="{ paddingBottom: tabHeight + 'px' }">
    <van-loading
      v-if="isLoading"
      color="#1989fa"
      style="
        position: fixed;
        top: 15%;
        left: 50%;
        transform: translate(-50%, -50%);
      "
    />
    <template v-else>
      <van-nav-bar
        title="选择课程视频"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
      />
      <div
        v-if="periods.length"
        class="w-full h-full layout-side course"
        style="height: calc(100% - 1.22667rem)"
      >
        <div class="h-full course-l">
          <div
            class="w-full course-l-item"
            :class="[
              selectedItem.train_id === p.train_id
                ? 'course-l-item-selected'
                : '',
            ]"
            v-for="(p, index) in periods"
            :key="'periods_' + index"
            @click="onActivePeriods(p)"
          >
            {{ p.course_name }}
          </div>
        </div>
        <div class="h-full course-r pc-grid">
          <div
            class="course-r-item w-full layout-side pc-col"
            v-for="(c, index) in courses"
            :key="'course_' + index"
            style="height: auto"
          >
            <div
              class="es-block"
              style="border-radius: var(--base-px-8); color: white; width: 100%"
              @click="onShare(c)"
            >
              <div style="padding-top: 57.8%"></div>
              <div class="">
                <img :src="c.image" style="width: 100%; height: 100%" />

                <div
                  class="es es-ver"
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    background: rgba(0, 0, 0, 0.2);
                  "
                >
                  <div
                    class="es-omit"
                    style="
                      font-size: var(--base-px-13);
                      font-weight: 500;
                      margin-left: var(--base-px-8);
                      font-weight: 600;
                      margin-top: 8px;
                    "
                  >
                    {{ c.title }}
                  </div>
                  <div class="es-f1"></div>
                  <div
                    style="
                      font-size: var(--base-px-11);
                      margin-left: var(--base-px-8);
                      margin-bottom: 6px;
                      line-height: var(--base-px-16);
                    "
                  >
                    <div>开始时间：{{ c.start_time }}</div>
                    <div style="margin-top: var(--base-px-2)">
                      结束时间：{{ c.end_time }}
                    </div>
                  </div>
                </div>
                <div
                  class="es es-ac es-pc"
                  style="
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                  "
                >
                  <img
                    style="
                      width: var(--base-px-36);
                      height: var(--base-px-36);
                      border-radius: 0;
                    "
                    src="../../assets/course/play.png"
                  />
                </div>
              </div>
            </div>
            <div
              class="es es-ac"
              style="
                width: 100%;
                padding-top: var(--base-px-12);
                font-size: var(--base-px-13);
                padding-bottom: var(--base-px-2);
              "
            >
              <div>时长：{{ c.times }}</div>
              <div class="es-f1"></div>
              <div
                class="layout-right-center"
                @click.stop="onShare(c)"
                style="
                  font-size: var(--base-px-12);
                  color: #1a89f9;
                  margin-left: var(--base-px-5);
                "
                v-if="!userDatalt.isDealer"
              >
                <img
                  style="
                    width: var(--base-px-10);
                    height: var(--base-px-10);
                    margin-right: var(--base-px-4);
                    margin-top: var(--base-px-2);
                  "
                  src="../../assets/course/2.png"
                /><span>分享</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <van-empty v-else description="暂无数据" />
    </template>

    <div
      class="data-count-model-1"
      v-show="showShare"
      @click="onShareClose()"
      style="
        position: fixed;
        top: 0;
        left: 0;
        z-index: 98;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
      "
    ></div>
    <div
      class="data-count-model-1 data-count-model-2"
      v-show="showShare"
      style="
        height: 20%;
        border-radius: var(--base-px-16) var(--base-px-16) 0px 0px;
        z-index: 2002;
        bottom: 0;
        left: 0;
        width: 100%;
        position: fixed;
        max-height: 100%;
        overflow-y: auto;
        background-color: #fff;
        transition: transform 0.3s, -webkit-transform 0.3s;
      "
    >
      <div
        class="w-full layout-left-center es es-f1"
        style="padding-top: var(--base-px-12)"
      >
        <div
          class="es-f1 es-ac"
          style="text-align: center"
          v-for="(item, index) in options"
          :key="'share_' + index"
          :id="'share' + index"
          :data-clipboard-text="item.url"
          @click="
            copy(
              item.url,
              'share' + index,
              item.title,
              item.image,
              item.miniAppId,
              item.pages
            )
          "
        >
          <img
            style="
              width: var(--base-px-48);
              height: var(--base-px-48);
              margin: 0 var(--base-px-16);
            "
            :src="item.icon"
            alt=""
          />
          <div
            class="layout-center"
            style="
              margin-top: var(--base-px-8);
              padding: 0 var(--base-px-4);
              color: #646566;
              font-size: var(--base-px-12);
            "
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div
        class="es-f1 es es-ac es-pc"
        style="
          font-size: var(--base-px-14);
          color: #333333;
          margin-top: var(--base-px-24);
        "
        @click="onShareClose()"
      >
        取消
      </div>
    </div>
    <van-overlay :show="show">
      <div class="wrapper">
        <div class="block">
          <div class="layout-center">
            <van-loading color="#1989fa" />
          </div>
          分享链接生成中，请等待
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import StatisticsPage from "@/views/index/components/statisticsPage.vue";
import {
  courseList,
  courseLessonList,
  createCourseSharingLink,
  trainLessonDataStatistics,
} from "@/api/course";
import wechatIcon from "@/assets/course/3.png";
import { ShareSheet } from "vant";
import Clipboard from "clipboard";

import { sendChatMessage } from "../../utils/wxCodeAuth";

export default {
  components: { StatisticsPage, ShareSheet },
  data() {
    return {
      text: "http://www.baidu.com&" + Math.round(Math.random() * 10),
      tabHeight: 0,
      // tab 切换
      active: 1,
      selectedItem: { id: "" },
      selectedCourse: null,
      periods: [],
      courses: [],
      userDatalt: {
        name: "",
      },
      showShare: false,
      options: [{ name: "分享链接", type: 1, icon: wechatIcon, url: "" }],
      show: false,

      data_model: false,
      train_lesson_id: "",
      isLoading: true,
    };
  },
  created() {
    this.userDetails();
    courseList().then((res) => {
      this.isLoading = false;
      this.periods = res.data;
      this.selectedItem = this.periods[0];
      if (this.selectedItem) {
        this.getCourseLessonList(this.selectedItem.train_id);
      }
    });
  },
  methods: {
    copy(url, id, title, image, miniAppId, pages) {
      // if (id === 'share0') {
      // 	message.error('暂不支持此分享方式');
      // 	return;
      // }

      if (id === "share2") {
        let miniData = {};
        //走企业微信发送小程序卡片消息接口
        miniData.appid = miniAppId;
        miniData.title = title;
        miniData.imgUrl = image;
        miniData.page = pages;
        sendChatMessage(6, miniData).then((res) => {
          this.$message.success("发送成功");
        });
        return;
      }
      const that = this;
      this.text = url;
      let clipBoard = new Clipboard(`#${id}`);
      clipBoard.on("success", function () {
        clipBoard.destroy(); //销毁上一次的复制内容
        clipBoard = new Clipboard(`#${id}`);
        that.$toast.success("复制成功");
      });
      clipBoard.on("error", function () {
        that.$dialog.confirm({
          title: "复制提示",
          message: `链接生成失败，请重新点击获取`,
          confirmButtonText: "我知道了",
        });
      });
    },
    onShareClose() {
      this.selectedCourse = null;
      this.showShare = false;
    },
    onClickLeft() {
      this.$router.back();
    },
    async onShare(item) {
      createCourseSharingLink({
        train_lesson_id: item.train_lesson_id,
        validity_time: "100",
        type: 4,
        user_id: this.$route.query.contactId,
      }).then((one) => {
        if (one.code == 1) {
          this.options[0].url = one.data.url;
        } else {
          that.$dialog.confirm({
            title: "提示",
            message: one.msg,
            confirmButtonText: "我知道了",
          });
        }
      });

      /*createCourseSharingLink({
				train_lesson_id: item.train_lesson_id,
				validity_time: '100',
				type: 2
			}).then(two => {
				this.options[1].url = two.data.url
			})

			createCourseSharingLink({
				train_lesson_id: item.train_lesson_id,
				validity_time: '100',
				type: 3
			}).then(two => {
				this.options[2].miniAppId = two.data.miniAppId
				this.options[2].pages = two.data.pages
			})

			this.options[2].title = item.title
			this.options[2].image = item.image*/

      setTimeout(() => {
        this.selectedCourse = item;
        this.showShare = true;
        this.showShare = false;
        this.showShare = true;
      }, 1000);
    },
    onData: function (data = false) {
      console.log("data11", data);
      trainLessonDataStatistics({ train_lesson_id: data.train_lesson_id }).then(
        (r) => {
          this.train_lesson_id = data.train_lesson_id;
          this.data_model = r.data;
        }
      );
    },
    userDetails() {
      const item = JSON.parse(localStorage.getItem("userDetails"));
      if (item) {
        this.userDatalt = item;
      }
    },
    getCourseLessonList(e) {
      courseLessonList({ train_id: e + "" }).then((r) => {
        this.courses = r.data;
      });
    },
    onActivePeriods(item) {
      console.log(item);
      console.log("11111");
      this.selectedItem = item;
      if (this.selectedItem) {
        this.getCourseLessonList(this.selectedItem.train_id);
      }
    },
    routerPush(e) {
      this.$router.push(e);
    },
  },
};
</script>

<style scoped lang="less">
@wait: #45c400;
@over: #c8cad0;
@finsh: red;

/deep/ .van-tabbar {
  box-sizing: content-box !important;
}

/deep/ .have-matter-wait {
  &:before {
    background: @wait;
    position: absolute;
    z-index: 88;
    content: "";
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: var(--base-px--2);
    width: var(--base-px-5);
    height: var(--base-px-5);
    border-radius: 50%;
    margin-left: var(--base-px-1);
    //background: #c8cad0;
  }
}

/deep/ .have-matter-over {
  &:before {
    background: @finsh;
    position: absolute;
    z-index: 88;
    content: "";
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: var(--base-px--2);
    width: var(--base-px-5);
    height: var(--base-px-5);
    border-radius: 50%;
    margin-left: var(--base-px-1);
    //background: #c8cad0;
  }
}

/deep/ .have-matter-finsh {
  &:before {
    background: @over;
    position: absolute;
    z-index: 88;
    content: "";
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    bottom: var(--base-px--2);
    width: var(--base-px-5);
    height: var(--base-px-5);
    border-radius: 50%;
    margin-left: var(--base-px-1);
    //background: #c8cad0;
  }
}

/deep/ .hide-icon .van-radio__icon {
  visibility: hidden;
}

/deep/ .hide-icon .van-radio__label {
  width: var(--base-px-126);
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.index {
  font-size: var(--base-px-14);
  min-height: 100%;
  background-color: #f2f3f7;
  width: 100%;

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    text-align: center;
    color: #ffffff;
    font-size: var(--base-px-12);
  }

  .course {
    padding: var(--base-px-12) 0 0 var(--base-px-12);

    &-l {
      width: var(--base-px-90);
      background: #ffffff;
      border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8)
        var(--base-px-8);
      font-weight: 400;
      font-size: var(--base-px-14);
      line-height: var(--base-px-16);
      text-align: center;
      font-style: normal;
      text-transform: none;
      padding: var(--base-px-4);

      &-item {
        padding: var(--base-px-12) 0;
        color: #333333;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;

        &-selected {
          color: #1a89f9;
        }
      }
    }

    &-r {
      width: calc(100% - var(--base-px-90));
      padding: 0 var(--base-px-12) 0 var(--base-px-12);
      overflow: auto;

      &-item {
        height: var(--base-px-80);
        background: #ffffff;
        border-radius: var(--base-px-8) var(--base-px-8) var(--base-px-8)
          var(--base-px-8);
        margin-top: var(--base-px-12);
        padding: var(--base-px-6);

        &:first-of-type {
          margin-top: 0;
        }

        &-l {
          width: var(--base-px-100);
          height: var(--px-56);
          position: relative;

          img {
            width: 100%;
            height: 100%;
            //border-radius: var(--base-px-8);
          }
        }

        &-r {
          width: calc(100% - var(--base-px-110));
          height: 100%;
          padding: var(--base-px-10) 0 var(--base-px-10) var(--base-px-12);

          &-top {
            font-weight: bold;
            font-size: var(--base-px-14);
            color: #333333;
            line-height: var(--base-px-16);
            text-align: left;
            font-style: normal;
            text-transform: none;
            overflow: hidden;
            height: var(--base-px-35);
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            /* 限制显示行数 */
            overflow: hidden;
            /* 隐藏溢出内容 */
            word-break: break-word;
            /* 处理长单词或URL换行 */
          }

          &-bottom {
            font-weight: 400;
            font-size: var(--base-px-12);
            color: #333333;
            line-height: var(--base-px-16);
            text-align: left;
            font-style: normal;
            text-transform: none;
            //margin-top: var(--base-px-13);
          }
        }
      }
    }
  }

  .tab {
    justify-content: space-between;
    //img {
    //	width: var(--base-px-22);
    //	height: var(--base-px-22);
    //}
  }
}

.es {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  position: relative;
}

.es-ver {
  flex-direction: column;
}

.es-ac {
  align-items: center;
}

.es-ae {
  align-items: flex-end;
}

.es-pc {
  justify-content: center;
}

.es-pe {
  justify-content: flex-end;
}

.es-f1 {
  flex-grow: 1;
}

.es-f2 {
  flex-grow: 2;
}

.es-f3 {
  flex-grow: 3;
}

.es-f4 {
  flex-grow: 4;
}

.es > div,
.es > div {
  flex-shrink: 0;
}

.es-f1,
.es-f2,
.es-f3,
.es-f4 {
  flex-shrink: 1 !important;
  overflow: hidden;
}

.es-block {
  position: relative;
  overflow: hidden;
}

.es-block > div:nth-child(1) {
  padding-top: 100%;
  width: 100%;
}

.es-block > div:nth-child(2) {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  overflow: hidden;
  z-index: 1;
}

.es-block > div:nth-child(3) {
  position: absolute;
  overflow: hidden;
  z-index: 2;
}

.es-omit,
.es-omit-1 {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.data-model-item {
  height: var(--base-px-20);
  border-radius: var(--base-px-8);
  margin: var(--base-px-3);
}

.data-model-item-ac {
  background-color: white;
  color: #1a89f9;
}
</style>
